import request from "@/utils/request";
import { handlerGetUrlParams } from "@/utils/dealUrlParams.js";
// 菜单查询
export function getMenu() {
    return request({
      url: "/system/menu/treeselect",
      method: "GET"
    });
}

// 角色查询
export function getRole(data) {
    const url = handlerGetUrlParams("/system/role/countList", data);
    return request({
      url,
      method: "GET"
    });
}

// 获取角色选择列表
export function roleList(data) {
  const url = handlerGetUrlParams("/system/role/optionselect", data);
    return request({
      url,
      method: "POST",
      data
    });
}
// 新增角色
export function addRole(data) {
    return request({
      url: "/system/role",
      method: "POST",
      data
    });
}

// 编辑角色
export function editRole(data) {
    return request({
      url: "/system/role",
      method: "PUT",
      data
    });
}

// 删除角色
export function deleteRole(ids) {
    return request({
      url: "/system/role/"+ids,
      method: "DELETE"
    });
}

// 查询已分配的角色列表
export function allocatedList(data) {
    return request({
      url: "/system/role/authUser/allocatedList",
      method: "POST",
      data
    });
}

// 查询已分配的角色列表
export function countTreeselect() {
    return request({
      url: "/system/dept/count_treeselect",
      method: "GET"
    });
}

// 用户列表
export function userList(data) {
    return request({
      url: "/system/user/search_user",
      method: "POST",
      data
    });
}
// 角色列表新增用户
export function addUserRole(data) {
    return request({
      url: "/system/role/add_user_role/"+data.id,
      method: "POST",
      data
    });
}
// 角色列表删除
export function delUserRole(data) {
    return request({
      url: "/system/role/delete_user_role/"+data,
      method: "DELETE"
    });
}